import { all, fork } from 'redux-saga/effects'
import { router, createBrowserHistory } from 'redux-saga-router'

import routes from './routes'
import socialShare from './socialShare'
import notificationSystem from './notifications'

const history = createBrowserHistory()

export default function* mainSaga () {
  yield all([
    fork(router, history, routes),
    fork(notificationSystem),
    fork(socialShare)
  ])
}



// WEBPACK FOOTER //
// app/javascript/src/sagas/index.js